import { useQuery } from '@tanstack/react-query'
import type { Tables } from '@/lib/database.types'
import { unwrap } from '@/lib/errors'
import { qk } from '@/lib/query-keys'
import { supabase } from '@/lib/supabase'
import { useAuth } from './AuthProvider'

/** Resultado de public.get_my_account(). */
export type Account = {
  profile: Tables<'profiles'>
  settings: Omit<Tables<'profile_settings'>, 'user_id'>
  email: string
  onboarded: boolean
  suspended: boolean
  counts: { votes: number; comments: number; suggestions: number; proposals: number }
}

export async function fetchAccount(): Promise<Account> {
  return unwrap(await supabase.rpc('get_my_account')) as unknown as Account
}

/** Conta do usuário logado (perfil, consentimentos, suspensão). `data` é indefinido sem sessão. */
export function useAccount() {
  const { user } = useAuth()
  return useQuery({
    queryKey: qk.me.account,
    queryFn: fetchAccount,
    enabled: Boolean(user),
    staleTime: 30_000,
  })
}

export function isModerator(account: Account | undefined): boolean {
  return account?.profile.role === 'moderator' || account?.profile.role === 'admin'
}

export function isAdmin(account: Account | undefined): boolean {
  return account?.profile.role === 'admin'
}
